/*!
 * angular-aside - v1.4.0
 * https://github.com/dbtek/angular-aside
 * 2017-03-27
 * Copyright (c) 2017 İsmail Demirbilek
 * License: MIT
 */
!(function () {
    'use strict';
    angular.module('ngAside', ['ui.bootstrap.modal']);
})(),
    (function () {
        'use strict';
        angular.module('ngAside').factory('$aside', [
            '$uibModal',
            function (a) {
                var b = (this.defaults = { placement: 'left' }),
                    c = {
                        open: function (c) {
                            var d = angular.extend({}, b, c);
                            ['left', 'right', 'bottom', 'top'].indexOf(d.placement) === -1 &&
                                (d.placement = b.placement);
                            var e = ['left', 'right'].indexOf(d.placement) === -1 ? 'vertical' : 'horizontal';
                            return (
                                (d.windowClass =
                                    'ng-aside ' + e + ' ' + d.placement + (d.windowClass ? ' ' + d.windowClass : '')),
                                delete d.placement,
                                a.open(d)
                            );
                        }
                    };
                return angular.extend({}, a, c);
            }
        ]);
    })();
